<template>
  <div v-if="!fetching" class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <add-edit-session-modal
            :ref="sessionModal"
            :modal-id="sessionModal"
            :profile="profile"
            :session="selectedSession"
            @session-created="handleRefreshSessions"
            @session-updated="handleRefreshSessions"
        />
        <span class="search">
          <label>
            <img :src="searchIconSVG" />
            <input
              type="search"
              class="search-input"
              placeholder="Search your Sessions"
              v-model="searchStr"
            />
          </label>
        </span>
        <spreadsheet
          v-if="v2"
          ref="spreadsheet"
          :columns="columns"
          :content="content"
          :file-name="`${profile.firstname}_Sessions`"
          sheet-name="Sessions"
        />
        <spreadsheet-upload
          v-if="v2"
          ref="spreadsheet-upload"
          :columns="columns"
          @process-items="handleProcessSessions"
        />
      </div>
      <div class="sessions" role="tablist">
        <session-card
          v-for="(aSession, idx) in sessions"
          :session="aSession"
          :idx="idx"
          :key="`sess_${idx}`"
          @edit-session-click="handleEditSessionModal"
          @delete-session="handleDeleteSession"
          @add-data-click="handleAddDataButtonClick"
        />
      </div>
    </div>
    <vimeo-modal
      v-if="activeVideo"
      :id="authorSessionVideo"
      :videoId="activeVideo.videoId"
      :videoThumb="activeVideo.videoThumb ? activeVideo.videoThumb : null"
    />
    <delete-session-modal
      :modal-id="modalIdDelete"
      :item-type="itemTypeDelete"
      :item-name="itemNameDelete"
      :item-id="itemDeleteItemId"
      @delete-item="handleDeleteSessionConfirmation"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SessionCard from "./sessionCard";
import AddEditSessionModal from "./addEditSessionModal";
import DeleteSessionModal from "@/components/modals/modalDelete";
import vimeoModal from "@/components/common/vimeoModal";
import VideoHandling from "@/mixins/VideoHandling";
import UploadImage from "@/mixins/UploadImage";
import Spreadsheet from "@/components/common/spreadsheet";
import SpreadsheetUpload from "@/components/common/spreadsheetUpload";
import moment from "moment";

export default {
  name: "ManageTabSession",
  mixins: [UploadImage, VideoHandling],
  components: {
    SessionCard,
    AddEditSessionModal,
    vimeoModal,
    Spreadsheet,
    DeleteSessionModal,
    SpreadsheetUpload
  },
  props: {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      listSessions: "user/listSessions",
      getLocalSessionWithId: "user/getLocalPublishingWithId"
    }),
    sessions() {
      return this.listSessions.filter(session => {
        return session && session.session && session.session.title
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    },
    columns() {
      return this.convertFieldToColumn(this.fields);
    },
    content() {
      return this.convertItemsToContent(this.sessions);
    }
  },
  methods: {
    getSessions() {
      this.$store
          .dispatch("user/getListSessions")
          .then(data => {
            console.log("Sessions refreshed");
            console.log(data);
          })
          .catch(error => {
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          })
          .finally(() => {
            this.fetching = false;
          });
    },
    getListedSession(event, session) {
      if (event.target.getAttribute("aria-expanded") == "true") {
        if (session.status !== "draft") {
          //this means that it has at east been submitted
          this.activeSessions = [];
          let existingSession = this.listSessions.filter(
              lSession => lSession.id === session.id
          );
          if (existingSession.length == 0) {
            this.$store
                .dispatch("listings/getListPublishingById", session.id)
                .then(data => {
                  this.activeSessions = data; //TODO Decide wehre to keep this session
                  //console.log("thisSession => ", this.activeSessions);
                })
                .catch(error => {
                  //console.log("Error getting document: ", error);
                });
          } else {
            this.activeSessions = existingSession[0];
          }
        }
      } else return;
    },
    handleEditSessionModal(session) {
      this.selectedSession = session;
      if ( this.$refs[this.sessionModal].hasOwnProperty('showEditSession')) {
        this.$refs[this.sessionModal].showEditSession(session);
      }
    },
    async handleProcessSessions(jsonSessions) {
      // mark source:upload_<userId>_ts
      //Verify that header is valid
      let tStamp = new Date().valueOf();
      if (jsonSessions && Array.isArray(jsonSessions)) {
        for (const aSession of jsonSessions) {
          if (aSession) {
            aSession.source = `upload_${this.user.uid}_${tStamp}`;
            await this.handleAddSession(aSession)
                .then(response => {
                  this.success.push(aSession.title);
                  console.log(response);
                })
                .catch(err => {
                  console.log(`Error: ${err}`);
                });
          }
        }
      }
    },
    handleDeleteSession(session) {
      this.itemNameDelete = session.title;
      this.itemTypeDelete = "Publishing";
      this.itemDeleteItemId = session.id;
      this.$bvModal.show(this.modalIdDelete);
    },
    handleDeleteSessionConfirmation(sessionId) {
      this.deleteSession(sessionId);
      //console.log(`Delete ${sessionId}`);
    },
    handleFeatureClick(featureType, sessionId) {
      this.selectedSessionId = sessionId;
      this.selectedSession = this.getLocalSessionWithId(sessionId);
      //console.log(`Feature ${featureType} Session: ${this.selectedSessionId}`);
      this.$root.$emit("bv::toggle::collapse", featureType);
    },
    handleRefreshSessions() {
      this.getSessions();
    },
    handleSelectSessionForManagement() {
      this.$store
        .dispatch("user/setSelectedPublishingId", this.selectedSession.id)
        .then(data => {
          // console.log(`Session Id submitted`);
          // console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    handleViewClick(session, index) {
      // console.log("here => ", index);
      // this.showDashCard = true;
      this.trackPassing = session;
      this.showCard = true;
      this.$bvModal.show(`dashcard-${session.id}`);
    },
    convertFieldToColumn(fields) {
      const columns = JSON.parse(JSON.stringify(fields));
      columns.forEach(aColumn => {
        if (aColumn.hasOwnProperty("key")) {
          aColumn.value = aColumn.key;
          delete aColumn["key"];
        }
        if (aColumn.hasOwnProperty("sortable")) {
          delete aColumn["sortable"];
        }
        if (aColumn.hasOwnProperty("tdClass")) {
          delete aColumn["tdClass"];
        }
        if (aColumn.hasOwnProperty("formatter")) {
          delete aColumn["formatter"];
        }
        if (aColumn.hasOwnProperty("isAvail")) {
          delete aColumn["isAvail"];
        }
      });

      return columns;
    },
    convertItemsToContent() {
      const content = [];
      if (this.sessions && Array.isArray(this.sessions)) {
        let index = 1;
        this.sessions.forEach(anItem => {
          const session = anItem;
          const thisContent = {
            Index: index++,
            id: session.id,
            title: session.title,
            cover: session.imgURL,
            description: session.description,
            owner: "",
            status: "",
            copyright: session.copyright,
            isbn: session.isbn,
            language: session.language,
            pages: session.pages,
            _created_at: this.formatDate(session._created_at),
            _submitted_at: this.formatDate(session._submitted_at),
            _updated_at: this.formatDate(session._updated_at)
          };

          //TOOLS
          if (session.tools && Array.isArray(session.tools)) {
            let tools = "";
            session.tools.forEach(aTool => {
              const newTool = `(${aTool.toolId})${aTool.name}`;
              tools = tools.length > 0 ? `${tools},${newTool}` : newTool;
            });
            thisContent.tools = tools;
          }
          content.push(thisContent);
        });
      }
      return content;
    },
    formatDate(date) {
      //TODO- Move to mixin
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    submitSession(session) {
      let sessionType = "author";

      let owner = {
        firstname: this.profile.firstname ? this.profile.firstname : null,
        lastname: this.profile.lastname ? this.profile.lastname : null,
        imgURL: this.profile.imgURL ? this.profile.imgURL : null,
        profileName: this.profile._dashboards.guide.profileName
          ? this.profile._dashboards.guide.profileName
          : null, //will be global
        userId: this.profile.userId ? this.profile.userId : null
      };

      this.$store
        .dispatch("listings/submitPublishing", {
          session,
          owner,
          sessionType
        })
        .then(res => {
          if (res) {
            this.$store
              .dispatch("user/submitPublishing", session)
              .then(res => {
                this.getSessions();
                this.$store.dispatch("user/showNotification", {
                  title: "Session Submitted Successfully",
                  description:
                    "Your session has now been submitted for Review",
                  variant: "success"
                });
              });
          }
        });
    },
    deleteSession(id) {
      this.$store.dispatch("user/deletePublishing", id).then(res => {
        if (res) {
          this.$bvModal.hide(this.modalIdDelete);
          this.getSessions();
          this.del = false;
          this.$store.dispatch("user/showNotification", {
            title: "Sessions Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    showDeleteSession(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.sessionModal);
    },
    hideDeleteSession() {
      this.$bvModal.hide(this.sessionModal);
    },
    setRolesArray() {
      this.$typeAheadRolesData.forEach(e => this.rolesArray.push(e.text));
    },
    hideSessionModal(id) {
      this.$bvModal.hide(`dashcard-${id}`);
    },
    setLanguagesArray() {
      this.$typeAheadAboutsLanguage.forEach(e =>
        this.languagesArray.push(e.text)
      );
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.session.description = val.content;
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.sessionModal);
      this.refresh++;
    },
    getSessionId(length) {
      //move to mixin
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    resetForm() {
      this.session = {
        title: "",
        subtitle: "",
        description: "",
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        connections: [],
        engines: [],
        imgURL: "",
        roles: null,
        weeks: 0,
        price: 0,
        categories: "",
        languages: [],
        age: 3,
        leaningStyle: "",
        copyright: ""
      };
      this.seo = "";
      this.activeIndex = null;
      this.activeSessionStatus = null;
      this.trackContent = {};
    },
    handleAddDataButtonClick(session) {
      debugger; //1
     this.handleEditSessionModal(session);
    },
  },
  beforeMount() {},
  mounted() {
    this.fetching = false;
    this.getSessions();
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }

      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
    this.setRolesArray();
    this.setLanguagesArray();
    this.$store.dispatch("user/getListNames");
    this.$store.dispatch("user/getListRoles");
  },
  data() {
    return {
      v2: false,
      searchIconSVG: require("@/assets/svg/search-icon.svg"),
      success: [],
      modalIdDelete: "delete-modal-id",
      itemTypeDelete: null,
      itemNameDelete: null,
      itemDeleteItemId: null,
      showingMore: false,
      selectedSession: {},
      selectedSessionId: null,
      fetching: false,
      sessionModal: "session-modal",
      authorSessionVideo: "author-session-video",
      refresh: 1,
      showCard: false,
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      clear: false,
      trackContent: {},
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      uploadingImage: false,
      activeImage: "",
      imgDataUrl: "",
      imgURL: "",
      trackPassing: {},
      session: {
        title: "",
        description: {},
        subtitle: "",
        language: "",
        publisher: "",
        published_at: "",
        isbn: "",
        author: "", //Will be part of crew
        editor: "", //Will be part of crew
        illustrator: "", //Will be part of crew
        pages: null,
        reviews: null,
        price: null,
        tools: [], //------------
        series: [],
        sessionRights: "",
        keywords: [],
        adultContent: "",
        seo: [],
        spheres: [],
        guides: [],
        engines: [],
        connections: [],
        imgURL: "",
        weeks: 0,
        roles: null,
        categories: "",
        languages: null,
        age: 3,
        leaningStyle: "",
        Copyright: ""
      },
      rolesArray: [],
      languagesArray: [],
      activeVideo: null,
      processingVideo: false,
      activeSessionStatus: null,
      activeSession: null,
      engines: [],
      addedEngines: [],
      oldEngines: [],
      showEngine: false,
      showUpload: false,
      uploadingScreen: false,
      currIndex: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      cornerId: `corner`,
      qrId: `qr`,
      insightsId: `insights`,
      developmentId: `development`,
      dataId: `data`,
      fields: [
        { key: "id", sortable: true, label: "ID", isAvail: true, inSS: true },
        {
          key: "title",
          sortable: true,
          label: "Title",
          tdClass: "colWidth",
          isAvail: true,
          inSS: true
        },
        {
          key: "coverImage",
          label: "Cover",
          isAvail: true,
          inSS: false
        },
        { key: "description", label: "Description", isAvail: true, inSS: true },
        {
          key: "owner",
          label: "Owner",
          isAvail: true,
          inSS: true
        },
        {
          key: "editStatus",
          label: "Status",
          isAvail: true,
          inSS: false
        },
        {
          key: "status",
          label: "Status",
          isAvail: false,
          inSS: true
        },
        {
          key: "editInfo",
          label: "Actions",
          isAvail: true,
          inSS: false
        },
        {
          key: "feedback",
          label: "Feedback",
          isAvail: true,
          inSS: true
        },

        {
          key: "docURL",
          label: "DocURL",
          isAvail: false
        },
        { key: "isbn", label: "ISBN", isAvail: false },
        { key: "language", label: "Language", isAvail: false },
        { key: "pages", label: "Pages", isAvail: false },
        { key: "price", label: "Price", isAvail: false },
        { key: "category", label: "Category", isAvail: false },
        { key: "publisher", label: "Publisher", isAvail: false },
        { key: "status", label: "Status", isAvail: false },
        { key: "subtitle", label: "Subtitle", isAvail: false },
        { key: "tools", label: "TOOLS", isAvail: false },
        { key: "_created_at", label: "Created", isAvail: false },
        { key: "_submitted_at ", label: "Submitted", isAvail: false },
        { key: "_updated_at", label: "Updated", isAvail: false },
        { key: "copyright", label: "Copyright", isAvail: false },
        { key: "imgURL", label: "Cover", isAvail: false }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.session-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-sessions {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-session {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
  .editor {
    max-width: 100%;
    width: 100%;
    .editor__content {
      .ProseMirror {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8);
        border-radius: 20px;
        padding-left: 30px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        background: #fff;
        //border: 1px solid #ddd;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 44px;
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}
.del-session {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.sessions {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .session-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.tools {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.crew {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-crew {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-session-video {
      width: 0;
    }
    #guide-session-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
